import MyAccountCancelAIModal from './MyAccountCancelAIModal'

export default MyAccountCancelAIModal
// eslint-disable-next-line import/export
export * from './MyAccountCancelAIModal'
